import { tryCatchHelper } from '../../../helpers';
import { allEstudiantesAction } from '../../control_estudios/estudiantes/EstudiantesAction';
import { setActivoUsuariosAction } from '../usuarios/UsuariosAction';
import {
  ACTIVO_ENT_USUARIO,
  ALL_USU_ENTIDADES,
  LOADING_ALL_USU_ENTIDADES,
} from './UsuEntidadesReducer';
import {
  allUsuEntidadesService,
  createUsuEntidadesService,
  deleteUsuEntidadesService,
  oneUsuEntidadesService,
  searchUsuEntidadesService,
} from './UsuEntidadesService';

export const allUsuEntidadesAction = async (dispatch, params) => {
  try {
    dispatch({ type: LOADING_ALL_USU_ENTIDADES, payload: true });
    const res = await allUsuEntidadesService(params);

    if (res.status === 200) {
      dispatch({ type: ALL_USU_ENTIDADES, payload: res.data });
      dispatch({ type: LOADING_ALL_USU_ENTIDADES, payload: false });
      return res.data;
    }
    dispatch({ type: LOADING_ALL_USU_ENTIDADES, payload: false });
    return null;
  } catch (e) {
    alert(e.message);
  }
};

export const setActivoUsuEntidadesAction = async (dispatch, data) => {
  dispatch({
    type: ACTIVO_ENT_USUARIO,
    payload: data,
  });
  setActivoUsuariosAction(dispatch, data.usuario);
};

export const oneUsuEntidadesAction = async (dispatch, id) => {
  try {
    const res = await oneUsuEntidadesService(id);
    if (res.status === 200) {
      await setActivoUsuEntidadesAction(dispatch, res.data);
      await setActivoUsuariosAction(dispatch, res.data.usuario);
      return true;
    }
    return false;
  } catch (e) {
    alert(e.message);
  }
};

export const deleteUsuEntidadesAction = async (
  { dispatch, notify, isMisEntidades = false, isEstudiantes = false },
  id,
  params,
) => {
  try {
    const res = await deleteUsuEntidadesService(id);
    notify(res.data.message);
    await setActivoUsuariosAction(dispatch, null);
    if (isEstudiantes) {
      await allEstudiantesAction(dispatch, params);
    } else {
      if (!isMisEntidades) {
        await allUsuEntidadesAction(dispatch, params);
      }
    }
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};

export const saveUsuEntidadesAction = async (
  { dispatch, notify },
  data,
  params,
) => {
  try {
    const res = await createUsuEntidadesService(null, data);
    notify(res.data.message);
    await allUsuEntidadesAction(dispatch, params);
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};

export const searchUsuEntidadesAction = async (notify, params) => {
  try {
    const res = await searchUsuEntidadesService(params);
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};
